import React, { useState, useEffect, useContext } from "react";
import "echarts-wordcloud";
import ReactEcharts from "echarts-for-react";
import { SizeContext } from "layouts/AppMain";

type DataType = {
  name: string;
  value: number;
};

interface WordCloudProps {
  data: DataType[];
}

const color = [
  "#7ff4f7",
  "#489abb",
  "#5d65d8",
  "#3f5fd2",
  "#bd40a4",
  "#5B8FF9",
  "#5AD8A6",
  "#5D7092",
  "#F6BD16",
  "#E86452",
  "#6DC8EC",
  "#945FB9",
  "#FF9845",
  "#1E9493",
  "#FF99C3",
];

const getOption = (
  data: DataType[] = [],
  s: (n: number, b?: boolean) => number
) => {
  const option = {
    series: [
      {
        type: "wordCloud",
        shape: "rect",
        left: "center",
        top: "center",
        width: "90%",
        height: "90%",
        sizeRange: [s(12), s(28)],
        gridSize: s(4),
        textStyle: {
          normal: {
            fontFamily: "FZLanTingHei",
            fontWeight: "normal",
            color: () => color[Math.round(Math.random() * (color.length - 1))],
          },
        },
        silent: true,
        data: data.filter(({ name }) => !/其他|其它|N\/A/.test(name)),
      },
    ],
  };

  return option;
};

const WordCloud: React.FC<WordCloudProps> = ({ data }) => {
  const getSize = useContext(SizeContext);
  const [option, setOption] = useState<any>({});

  useEffect(() => {
    setOption(getOption(data, getSize));
  }, [data, getSize]);

  return (
    <ReactEcharts
      option={option}
      notMerge={true}
      style={{ width: "100%", height: "100%", position: "absolute" }}
    />
  );
};

export default WordCloud;
